export default {
  'pages.layouts.userLayout.title':
    'Efficiently synchronize production NOSQL and SQL data, supporting initial and incremental synchronization with index monitoring',
  'pages.login.accountLogin.tab': 'Account Login',
  'pages.login.accountLogin.errorMessage': 'Incorrect username/password',
  'pages.login.failure': 'Login failed, please try again!',
  'pages.login.success': 'Login successful!',
  'pages.login.username.placeholder': 'Username: admin',
  'pages.login.username.required': 'Please input your username!',
  'pages.login.password.placeholder': 'Password: admin',
  'pages.login.password.required': 'Please input your password!',
  'pages.login.phoneLogin.tab': 'Phone Login',
  'pages.login.phoneLogin.errorMessage': 'Verification Code Error',
  'pages.login.phoneNumber.placeholder': 'Phone Number',
  'pages.login.phoneNumber.required': 'Please input your phone number!',
  'pages.login.phoneNumber.invalid': 'Phone number is invalid!',
  'pages.login.captcha.placeholder': 'Verification Code',
  'pages.login.captcha.required': 'Please input verification code!',
  'pages.login.phoneLogin.getVerificationCode': 'Get Code',
  'pages.getCaptchaSecondText': 'sec(s)',
  'pages.login.rememberMe': '自动登录',
  'pages.login.forgotPassword': '忘记密码',
  'pages.login.submit': '登录',
  'pages.login.loginWith': '其他登录方式',
  'pages.login.registerAccount': 'Register Account',
  'pages.welcome.link': 'Welcome',
  'pages.welcome.alertMessage': 'Faster and stronger heavy-duty components have been released.',
  'pages.404.subTitle': 'Sorry, the page you visited does not exist.',
  'pages.404.buttonText': 'Back Home',
  'pages.admin.subPage.title': 'This page can only be viewed by Admin',
  'pages.admin.subPage.alertMessage':
    'Umi ui is now released, welcome to use npm run ui to start the experience.',
  'pages.searchTable.createForm.newRule': 'New Rule',
  'pages.searchTable.updateForm.ruleConfig': 'Rule configuration',
  'pages.searchTable.updateForm.basicConfig': 'Basic Information',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'Rule Name',
  'pages.searchTable.updateForm.ruleName.nameRules': 'Please enter the rule name!',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'Rule Description',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': 'Please enter at least five characters',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    'Please enter a rule description of at least five characters!',
  'pages.searchTable.updateForm.ruleProps.title': 'Configure Properties',
  'pages.searchTable.updateForm.object': 'Monitoring Object',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'Rule Template',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'Rule Type',
  'pages.searchTable.updateForm.schedulingPeriod.title': 'Set Scheduling Period',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': 'Starting Time',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': 'Please choose a start time!',
  'pages.searchTable.titleDesc': 'Description',
  'pages.searchTable.ruleName': 'Rule name is required',
  'pages.searchTable.titleCallNo': 'Number of Service Calls',
  'pages.searchTable.titleStatus': 'Status',
  'pages.searchTable.nameStatus.default': 'default',
  'pages.searchTable.nameStatus.running': 'running',
  'pages.searchTable.nameStatus.online': 'online',
  'pages.searchTable.nameStatus.abnormal': 'abnormal',
  'pages.searchTable.titleUpdatedAt': 'Last Scheduled at',
  'pages.searchTable.exception': 'Please enter the reason for the exception!',
  'pages.searchTable.titleOption': 'Option',
  'pages.searchTable.config': 'Configuration',
  'pages.searchTable.subscribeAlert': 'Subscribe to alerts',
  'pages.searchTable.title': 'Enquiry Form',
  'pages.searchTable.new': 'New',
  'pages.searchTable.chosen': 'chosen',
  'pages.searchTable.item': 'item',
  'pages.searchTable.totalServiceCalls': 'Total Number of Service Calls',
  'pages.searchTable.tenThousand': '0000',
  'pages.searchTable.batchDeletion': 'batch deletion',
  'pages.searchTable.batchApproval': 'batch approval',
  'pages.password.title': 'Change Admin Password',
  'pages.password.oldPassword': 'Current Password',
  'pages.password.newPassword': 'New Password',
  'pages.password.confirmPassword': 'Confirm Password',
  'pages.password.inputOldPassword': 'Please input current password',
  'pages.password.inputNewPassword': 'Please input new password',
  'pages.password.inputConfirmPassword': 'Please confirm new password',
  'pages.password.passwordMismatch': 'The two passwords do not match',
  'pages.password.passwordTooShort': 'Password must be at least 6 characters',
  'pages.password.success': 'Password changed successfully',
  'pages.password.failure': 'Failed to change password',
  'pages.password.current.error': 'Current password is incorrect',
  'pages.userManage.title': 'User Management',
  'pages.userManage.username': 'Username',
  'pages.userManage.email': 'Email',
  'pages.userManage.currentAccess': 'Current Role',
  'pages.userManage.newAccess': 'New Role',
  'pages.userManage.apply': 'Apply',
  'pages.userManage.cancel': 'Cancel',
  'pages.userManage.loadFailed': 'Failed to load user list',
  'pages.userManage.updateSuccess': 'User roles updated successfully',
  'pages.userManage.updateFailed': 'Failed to update user roles',
  'pages.userManage.status': 'Status',
  'pages.userManage.active': 'Active',
  'pages.userManage.inactive': 'Inactive',
  'pages.userManage.changeStatus': 'Change Status',
  'pages.userManage.actions': 'Actions',
  'pages.userManage.delete': 'Delete',
  'pages.userManage.deleteConfirm': 'Are you sure you want to delete this user?',
  'pages.userManage.yes': 'Yes',
  'pages.userManage.no': 'No',
  'pages.userManage.deleteSuccess': 'User deleted successfully',
  'pages.userManage.deleteFailed': 'Failed to delete user',

  'pages.googleCallback.processing': 'Processing Google login...',
  'pages.googleCallback.success': 'Login Successful',
  'pages.googleCallback.debug': 'Google Login Debug',
  'pages.googleCallback.enterHome': 'Enter Homepage',
  'pages.googleCallback.retry': 'Retry Authentication',
  'pages.googleCallback.returnLogin': 'Return to Login',
  'pages.googleCallback.initializing': 'Initializing...',
  'pages.googleCallback.processingCode': 'Processing Google authorization code...',
  'pages.googleCallback.apiTimeout': 'API request timeout!',
  'pages.googleCallback.noAuthCode': 'No authorization code found, please check URL format',
  'pages.googleCallback.tokenSaved': 'Access token saved, length: ',
  'pages.googleCallback.loginSuccess': 'Google login successful',
  'pages.googleCallback.userStateUpdated': 'User state updated, preparing to redirect...',
  'pages.googleCallback.manualProcessing': 'Manually processing authorization code...',
  'pages.googleCallback.noAuthCodeFound': 'No authorization code found in URL',
  'pages.googleCallback.componentLoaded': 'Component loaded, processing callback...',
  'pages.googleCallback.foundAuthCode': 'Found authorization code: ',
  'pages.googleCallback.loginFailed': 'Login processing failed',

  'pages.dashboard.title': 'Data Sync Dashboard',
  'pages.dashboard.syncStatus': 'Sync Status',
  'pages.dashboard.healthyFlows': 'Healthy Flows',
  'pages.dashboard.currentLatency': 'Current Latency',
  'pages.dashboard.comparedLastWeek': 'Compared to Last Week',
  'pages.dashboard.rowsSyncedToday': 'Rows Synced Today',
  'pages.dashboard.tableRowCountTrend': 'Table Row Count Trend',
  'pages.dashboard.showSource': 'Show Source',
  'pages.dashboard.showTarget': 'Show Target',
  'pages.dashboard.showDiff': 'Show Diff',
  'pages.dashboard.activeDataFlows': 'Active Data Flows',
  'pages.dashboard.dataFlow': 'Data Flow',
  'pages.dashboard.status': 'Status',
  'pages.dashboard.latency': 'Latency',
  'pages.dashboard.changesCount': 'Changes',
  'pages.dashboard.flowDetails': 'Flow Details',
  'pages.dashboard.mappings': 'Field Mappings',
  'pages.dashboard.transformations': 'Transformations',
  'pages.dashboard.metrics': 'Performance Metrics',
  'pages.dashboard.syncsToday': 'Syncs Today',
  'pages.dashboard.avgLatency': 'Average Latency',
  'pages.dashboard.active': 'Active',
  'pages.dashboard.warning': 'Warning',
  'pages.dashboard.error': 'Error',
  'pages.dashboard.paused': 'Paused',
  'pages.dashboard.lastHour': 'Last Hour',
  'pages.dashboard.last3Hours': 'Last 3 Hours',
  'pages.dashboard.last6Hours': 'Last 6 Hours',
  'pages.dashboard.last12Hours': 'Last 12 Hours',
  'pages.dashboard.lastDay': 'Last Day',
  'pages.dashboard.last2Days': 'Last 2 Days',
  'pages.dashboard.last7Days': 'Last 7 Days',
  'pages.dashboard.custom': 'Custom',
  'pages.dashboard.dataNotice': 'Data Source Notice',
  'pages.dashboard.dataNoticeDetail':
    'Only "Table Row Count Trend" shows real data in this dashboard. Other metrics and data flows are simulated data.',
  'pages.dashboard.mockDataHint': 'Mock data for demonstration only',
  'pages.dashboard.realData': 'Real Data',

  'pages.dashboard.changeStreamsNotice': 'ChangeStreams Status Dashboard',
  'pages.dashboard.changeStreamsNoticeDetail':
    'Real-time data synchronization status from ChangeStreams API. Dashboard displays live sync metrics and stream health information.',
  'pages.dashboard.activeStreams': 'Active Streams',
  'pages.dashboard.processingRate': 'Processing Rate',
  'pages.dashboard.totalExecuted': 'Executed',
  'pages.dashboard.totalReceived': 'Received',
  'pages.dashboard.totalPending': 'Pending: {count}',
  'pages.dashboard.totalTasks': '{count} Tasks',
  'pages.dashboard.realTime': 'Real-time',
  'pages.dashboard.lastUpdated': 'Last Updated: {time}',
  'pages.dashboard.noData': 'No data available',
  'pages.dashboard.activeChangeStreams': 'Active ChangeStreams',
  'pages.dashboard.streamName': 'Stream Name',
  'pages.dashboard.received': 'Received',
  'pages.dashboard.executed': 'Executed',
  'pages.dashboard.inserted': 'Inserted',
  'pages.dashboard.updated': 'Updated',
  'pages.dashboard.deleted': 'Deleted',
  'pages.dashboard.totalInserted': 'Inserted',
  'pages.dashboard.totalUpdated': 'Updated',
  'pages.dashboard.totalDeleted': 'Deleted',
  'pages.dashboard.pending': 'Pending',
  'pages.dashboard.errors': 'Errors',
  'pages.dashboard.taskId': 'Task ID',
  'pages.dashboard.processing': 'Processing',
  'pages.dashboard.idle': 'Idle',
  'pages.dashboard.progress': 'Progress',
  'pages.dashboard.details': 'Details',
  'pages.dashboard.executedOfTotal': '{executed} of {total} executed',
  'pages.dashboard.realDataHint': 'Real-time data from ChangeStreams API',
  'pages.dashboard.streamInfo': 'Stream Information',
  'pages.dashboard.streamCount': 'Streams',
  'pages.dashboard.streamDetails': 'Stream Details',

  'pages.settings.auth.title': 'Authentication Settings',
  'pages.settings.auth.enableOAuth': 'Enable {provider} Account Login',
  'pages.settings.auth.uploadConfig': 'Upload {provider} OAuth Configuration File',
  'pages.settings.auth.configFileHint':
    'Please upload the OAuth client JSON configuration file from {provider}',
  'pages.settings.auth.selectFile': 'Select File',
  'pages.settings.auth.jsonFileOnly': 'You can only upload JSON files!',
  'pages.settings.auth.fileSizeLimit': 'File must be smaller than 2MB!',
  'pages.settings.auth.loading': 'Loading settings...',
  'pages.settings.auth.save': 'Save Settings',
  'pages.settings.auth.saveSuccess': 'Settings saved successfully',
  'pages.settings.auth.saveFailed': 'Failed to save settings',
  'pages.settings.auth.fetchFailed': 'Failed to fetch settings',
  'pages.settings.auth.configHelp.title': 'Configuration Help',
  'pages.settings.auth.configHelp.description':
    'You need to create an OAuth client ID in {provider} and download the JSON configuration file. Make sure you have set the correct redirect URI for your application callback.',
  'pages.settings.auth.configHelp.hint':
    'New OAuth settings will take effect after system restart.',
  'pages.settings.auth.currentConfig': 'Current Configuration',
  'pages.settings.auth.clientId': 'Client ID: {id}',
  'pages.settings.auth.redirectUri': 'Redirect URI: {uri}',
  'pages.settings.auth.scopes': 'Authorization Scopes: {scopes}',
  'pages.settings.auth.enableGoogleOAuth': 'Enable Google Account Login',
  'pages.settings.auth.fileContentError':
    'Unable to get file content, please select the file again',
  'pages.settings.auth.jsonParseError': 'Failed to parse JSON file, please verify the file format',
  'pages.settings.auth.fileReadError': 'Failed to read file',
  'pages.settings.auth.missingClientId': 'Configuration file is missing client_id field',
  'pages.settings.auth.missingClientSecret': 'Configuration file is missing client_secret field',
  'pages.settings.auth.missingRedirectUri': 'Configuration file is missing redirect_uri field',
  'pages.settings.auth.apiRequestFailed': 'API request failed: {message}',
  'pages.settings.auth.configProcessError':
    'Unknown error occurred while processing configuration file',
  'pages.settings.auth.updateSettingsFailed': 'Failed to update settings',

  'pages.login.oauthLogin': 'Login with {provider}',
  'pages.login.googleLogin': 'Login with Google',
  'pages.settings.auth.uploadGoogleConfig': 'Upload Google OAuth Configuration File',
  'pages.settings.auth.googleConfigFileHint':
    'Please upload the OAuth client JSON configuration file from Google Cloud Console',
  'pages.settings.auth.googleConfigHelp.description':
    'You need to create an OAuth client ID in Google Cloud Console and download the JSON configuration file. Make sure you have set the correct redirect URI for your application callback.',

  'pages.syncSettings.advancedSecurity': 'Advanced Security Options (Field Encryption/Masking)',
  'pages.syncSettings.table': 'Table: ',
  'pages.syncSettings.fieldName': 'Field Name',
  'pages.syncSettings.fieldType': 'Type',
  'pages.syncSettings.fieldStatus': 'Status',
  'pages.syncSettings.operation': 'Operation',
  'pages.syncSettings.status.normal': 'Normal',
  'pages.syncSettings.status.masked': 'Masked',
  'pages.syncSettings.status.encrypted': 'Encrypted',
  'pages.syncSettings.action.mask': 'Mask',
  'pages.syncSettings.action.encrypt': 'Encrypt',
  'pages.syncSettings.action.restore': 'Restore',
  'pages.syncSettings.message.fieldStatusChanged':
    'The status of field {field} in table {table} has been changed to {status}',
  'pages.syncSettings.fetchFieldsFailed': 'Failed to fetch table fields',
  'pages.syncSettings.loadingFields': 'Loading fields...',
  'pages.syncSettings.missingConnectionInfo':
    'Connection information is incomplete, unable to fetch table fields',

  'pages.sync.fieldName': 'Field Name',
  'pages.sync.fieldType': 'Field Type',
  'pages.sync.securityOptions': 'Security Options',
  'pages.sync.encrypt': 'Encrypt',
  'pages.sync.mask': 'Mask',
  'pages.sync.restore': 'Restore',
  'pages.sync.tableFieldInfo': 'Table Field Info',
  'pages.sync.advancedSecurity': 'Advanced Security Options',
  'pages.sync.enableAdvancedSecurity': 'Enable Advanced Security',
  'pages.sync.testConnection': 'Test Connection',
  'pages.sync.updateSucesss': 'Update successful',
  'pages.sync.addSucesss': 'Add successful',
  'pages.sync.updateFailed': 'Update failed',
  'pages.sync.addFailed': 'Add failed',
  'pages.sync.selectSourceType': 'Please select a Source Type',
  'pages.sync.completeSourceConn': 'Please complete the source connection information',
  'pages.sync.sourceConnSuccess': 'Source DB connection successful',
  'pages.sync.sourceConnFailed': 'Source DB connection failed',
  'pages.sync.completeTargetConn': 'Please complete the target connection information',
  'pages.sync.targetConnSuccess': 'Target DB connection successful',
  'pages.sync.targetConnFailed': 'Target DB connection failed',
  'pages.sync.testConnError': 'Error testing connection',
  'pages.sync.sourceConnAutoSuccess': 'Source DB connection successful (auto load)',
  'pages.sync.sourceConnAutoFailed': 'Source DB connection failed (auto load)',
  'pages.sync.targetConnAutoSuccess': 'Target DB connection successful (auto load)',
  'pages.sync.targetConnAutoFailed': 'Target DB connection failed (auto load)',
  'pages.sync.availableTables': 'Available Tables',
  'pages.sync.selectedTables': 'Selected',
  'pages.sync.editConfig': 'Edit Data Sync Configuration',
  'pages.sync.addConfig': 'Add Data Sync Configuration',
  'pages.sync.sourceType': 'Source Type',
  'pages.sync.sourceDBConn': 'Source DB Connection',
  'pages.sync.targetDBConn': 'Target DB Connection',
  'pages.sync.tableMapping': 'Table/Collection Mapping',
  'pages.sync.taskName': 'Task Name',
  'pages.sync.pleaseEnterTaskName': 'Please enter the task name',
  'pages.sync.pleaseSelectSourceType': 'Please select the source type',
  'pages.sync.host': 'Host',
  'pages.sync.port': 'Port',
  'pages.sync.username': 'Username',
  'pages.sync.password': 'Password',
  'pages.sync.databaseName': 'Database Name',
  'pages.sync.pleaseEnterSourceHost': 'Please enter the source DB host',
  'pages.sync.pleaseEnterSourcePort': 'Please enter the source DB port',
  'pages.sync.pleaseEnterSourceDB': 'Please enter the source DB name',
  'pages.sync.pleaseEnterTargetHost': 'Please enter the target DB host',
  'pages.sync.pleaseEnterTargetPort': 'Please enter the target DB port',
  'pages.sync.pleaseEnterTargetDB': 'Please enter the target DB name',
  'pages.sync.pleaseEnterSourceUsername': 'Please enter source username',
  'pages.sync.pleaseEnterSourcePassword': 'Please enter source password',
  'pages.sync.pleaseEnterTargetUsername': 'Please enter target username',
  'pages.sync.pleaseEnterTargetPassword': 'Please enter target password',
  'pages.sync.securityEnabled': 'Enabled',
  'pages.sync.securityDisabled': 'Disabled',

  'pages.sqlDebug.title': 'SQL Debug Tool',
  'pages.sqlDebug.selectTask': 'Select Sync Task',
  'pages.sqlDebug.templates': 'Templates',
  'pages.sqlDebug.select': 'Query',
  'pages.sqlDebug.insert': 'Insert',
  'pages.sqlDebug.update': 'Update',
  'pages.sqlDebug.delete': 'Delete',
  'pages.sqlDebug.executeSource': 'Execute in Source',
  'pages.sqlDebug.executeTarget': 'Execute in Target',
  'pages.sqlDebug.executeBoth': 'Execute in Both',
  'pages.sqlDebug.sourceResult': 'Source DB Result',
  'pages.sqlDebug.targetResult': 'Target DB Result',
  'pages.sqlDebug.noResult': 'No data yet',
  'pages.sqlDebug.refresh': 'Refresh',
  'pages.sqlDebug.loadTasksFailed': 'Failed to load sync tasks',
  'pages.sqlDebug.selectTaskFirst': 'Please select a sync task first',
  'pages.sqlDebug.enterSqlFirst': 'Please enter SQL first',
  'pages.sqlDebug.sourceQuerySuccess': 'Source query successful',
  'pages.sqlDebug.sourceQueryFailed': 'Source query failed',
  'pages.sqlDebug.sourceQueryError': 'Error in source query',
  'pages.sqlDebug.targetQuerySuccess': 'Target query successful',
  'pages.sqlDebug.targetQueryFailed': 'Target query failed',
  'pages.sqlDebug.targetQueryError': 'Error in target query',
  'pages.sqlDebug.affectedRows': 'Affected Rows',
  'pages.sqlDebug.executionTime': 'Execution Time',
  'pages.sqlDebug.message': 'Message',
  'pages.sqlDebug.source': 'Source',
  'pages.sqlDebug.target': 'Target',
  'pages.sqlDebug.redisNotSupported':
    'Redis data source does not support SQL operations, please use Redis commands',

  // Backup related internationalization
  'pages.backup.form.fileNamePattern': '文件名模式（正则表达式）',
  'pages.backup.form.fileNamePattern.required': '请输入文件名模式',
  'pages.backup.form.fileNamePattern.placeholder': '例如：^{table}_\\d{4}-\\d{2}-\\d{2}_.*\\.json$',
  'pages.backup.form.fileNamePattern.invalid': '无效的正则表达式',
  'pages.backup.form.fileNamePattern.tooltip':
    '用于匹配备份文件名的正则表达式模式。鼠标悬停可查看匹配示例。',
};
